module.exports = __webpack_public_path__ + "img/live.a6e717fc.svg";